import React from "react"
import { useFormikWizard } from "formik-wizard"

const checkProperties = (obj) => {
  for (let key in obj) {
    if (obj[key] !== null && obj[key] !== "") return false
  }
  return true
}

const Nav = ({ currentStep, wizard }) => {
  const context = useFormikWizard()

  return (
    <div className="container">
      <div className="row">
        <div
          className={
            currentStep === "business_info"
              ? "contained col-lg-4"
              : "text col-lg-4"
          }
        >
          <button
            onClick={() => {
              wizard.push("business_info")
            }}
            className="btn"
          >
            Business Information
          </button>
        </div>

        <div
          className={
            currentStep === "additional_documents"
              ? "contained col-lg-4"
              : "text col-lg-4"
          }
        >
          <button
            onClick={() => {
              if (checkProperties(context.values.business_info)) {
                wizard.push("business_info")
              } else {
                wizard.push("additional_documents")
              }
            }}
            className="btn"
          >
            Additional Documents
          </button>
        </div>

        <div
          className={
            currentStep === "updates" ? "contained col-lg-4" : "text col-lg-4"
          }
        >
          <button
            onClick={() => {
              if (checkProperties(context.values.business_info)) {
                wizard.push("business_info")
              } else if (checkProperties(context.values.additional_documents)) {
                wizard.push("additional_documents")
              } else {
                wizard.push("updates")
              }
            }}
            className="btn"
          >
            Update(s)
          </button>
        </div>
      </div>
    </div>
  )
}

export default Nav
